export class DisconnectAction {
    constructor(shutdown = false) {
        this.name = 'Disconnect';
        this.isDeviceAction = true;
        this.data = { shutdown };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGlzY29ubmVjdEFjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWxzL2FjdGlvbnMvRGlzY29ubmVjdEFjdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLQSxNQUFNLE9BQU8sZ0JBQWdCO0lBSzNCLFlBQVksV0FBb0IsS0FBSztRQUpyQixTQUFJLEdBQUcsWUFBWSxDQUFDO1FBQ3BCLG1CQUFjLEdBQUcsSUFBSSxDQUFDO1FBSXBDLElBQUksQ0FBQyxJQUFJLEdBQUcsRUFBRSxRQUFRLEVBQUUsQ0FBQztJQUMzQixDQUFDO0NBQ0YifQ==